import InexCard from "../InexCard";
import { Box, Typography } from "@mui/material";
import React from "react";

import { ReactComponent as EyeIcon } from "../../resources/images/svg/home/podcasts/eye.svg";

const BookCard = ({ book, ...props }) => {
  return (
    <a 
      href={`https://www.inexplore.com/livre/${book.id}`} 
      target="_blank"
    >
      <InexCard
        {...props}
        sx={{
          padding: 0,
          paddingTop: 0,
          paddingBottom: 0,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: "100%",
          userSelect: "none",
          flexGrow: 1,
          backgroundColor: "transparent",
          boxShadow: "none",
          transition: "transform 0.2s",
          "&:hover": {
            transform: "scale(1.05)",
          },
          ...props.sx
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            overflow: "hidden",
            position: "relative",
            aspectRatio: 297 / 432,
            "& > img": {
              objectFit: "cover",
              width: "100%",
              height: "100%",
            },
            backgroundColor: "#ffffffbb",
          }}
        >
          <img src={book.image} alt={"magazineImage"} />
        </Box>
        <Box
          sx={{
            display: "flex",
            marginTop: 2,
            flexDirection: "column",
            width: 255
          }}
        >
          <Typography
            sx={{
              fontFamily: "Branding SemiBold",
              fontSize: "18px",
              textOverflow: "ellipsis",
              overflow: "hidden",
              color: "white",
              verticalAlign: "top",
              fontWeight: "bold",
            }}
          >
            {book.titre}
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 1,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <EyeIcon />
          <Typography
            sx={{
              marginLeft: 1,
              color: "#A5D0C9",
              fontWeight: "bold",
            }}
          >
            Voir le livre
          </Typography>
        </Box>
      </InexCard>
    </a>
  );
};

export default BookCard;
